'use client';
import { useToast } from '@dolcevia/lib/hooks/useToast';
import {
  ToggleGroup,
  ToggleGroupItem,
} from '@dolcevia/ui/components/ui/toggle-group';
import {
  Link1Icon,
  LinkedInLogoIcon,
  TwitterLogoIcon,
} from '@radix-ui/react-icons';
import { useTranslations } from 'next-intl';

export const ShareButtons = () => {
  const t = useTranslations('Posts.shareButton');
  const { toast } = useToast();
  return (
    <div className="flex flex-col justify-start">
      <p className="font-semibold text-midnight-100">
        {t('Partagez cet article')}
      </p>
      <ToggleGroup
        type="single"
        variant="outline"
        className="items-start justify-start"
      >
        <ToggleGroupItem
          onClick={async () => {
            await navigator.clipboard.writeText(window.location.href);

            toast({
              description: 'Lien copié dans le presse-papier',
            });
          }}
          value="bold"
          aria-label="Toggle bold"
        >
          <Link1Icon className="h-4 w-4" />
        </ToggleGroupItem>
        <ToggleGroupItem
          onClick={() => {
            window.open(
              `https://twitter.com/share?url=${window.location.href}`,
              '_blank',
            );
          }}
          value="italic"
          aria-label="Toggle italic"
        >
          <TwitterLogoIcon className="h-4 w-4" />
        </ToggleGroupItem>
        <ToggleGroupItem
          value="strikethrough"
          aria-label="Toggle strikethrough"
          onClick={() => {
            window.open(
              `https://www.linkedin.com/shareArticle?mini=true&url=${window.location.href}`,
              '_blank',
            );
          }}
        >
          <LinkedInLogoIcon className="h-4 w-4" />
        </ToggleGroupItem>
      </ToggleGroup>
    </div>
  );
};
